import React, { Component } from 'react';
import { connect } from 'react-redux';
import Blank from '../../../hoc/Blank/Blank';
import Table from '../../../components/UI/Table/Table';
import Spinner from '../../../components/UI/Spinner/Spinner';
import SalesSummary from '../../../components/Order/SalesSummary/SalesSummary';
import 'react-toastify/dist/ReactToastify.min.css' ;
import { ToastContainer,toast } from 'react-toastify';
import * as actions from '../../../store/actions/index';

class ShowOrders extends Component {
  componentDidMount() {
    if (this.props.result == "0") {
      this.props.onFetchScoutOrders();
    }
    this.props.onGetSalesSummary(true);
    window.scrollTo(0,0);
  }

  state = {
    showEditOrder: false,
    showSuccess: false,
    orderId: 0,
    editOrder: null,
    updated: false,
    result: null
  }

  componentDidUpdate(prevProps) {
      
      if (this.props.result != "0" && this.props.result != '') {
        let message = "The order was successfully added.";
        if ( this.props.result == "updated") {
           message = "The order was successfully updated.";
        }
        if (!this.state.result || this.state.result != this.props.result  ) {
          this.setState({result:this.props.result});
          toast(message);
        }
      }
  }
  
  showOrder = (e) => {
    this.setState({result:""});
    let oid = e.currentTarget.getAttribute('oid');
    this.props.history.push('/editOrder?' + oid);
  }


  render() {

    if (!this.props.loading) {
      var data = [];
      let pl = "30px";
      let fifty = "50px";
      let oneFifty = "150px";
      let seventyFive = "75px";

      if (window.innerWidth < 500) {
        pl = "5px";
        fifty = "40px";
        oneFifty = "100px";
        seventyFive = "50px";
      }


let i = -1;
for (let k1 in this.props.orders) {
  let order = this.props.orders[k1]
  i = i + 1;

        data.push({
          oid: order.orderId, data: [{
            value: order.orderId,
            style: { paddingLeft: pl, width: seventyFive },
            full: false
          },
          {
            value: order.name,
            style: { width: oneFifty, paddingLeft: pl },
            full: false
          },
          {
            value: order.address,
            style: { width: "200px", paddingLeft: pl },
            full: true
          },
          {
            value: order.phone,
            style: { width: seventyFive, paddingLeft: pl },
            full: true
          },
          {
            value: order.email,
            style: { width: oneFifty, paddingLeft: pl },
            full: true
          }
        ]})

        if (this.props.mulchYear.sellHardwood) {
          data[i].data.push(
          {
            value: order.hardwoodBags,
            style: { width: fifty, paddingLeft: pl },
            full: false
          })
        }
        if (this.props.mulchYear.sellCedar) {
          data[i].data.push(
          {
            value: order.cedarBags,
            style: { width: fifty, paddingLeft: pl },
            full: false
          })
        }

        if (this.props.mulchYear.sellBlack) {
          data[i].data.push(
          {
            value: order.blackBags,
            style: { width: fifty, paddingLeft: pl },
            full: false
          })
        }

        if (this.props.mulchYear.sellRed) {
          data[i].data.push(
          {
            value: order.redBags,
            style: { width: fifty, paddingLeft: pl },
            full: false
          })
        }

        data[i].data.push(
          {
            value: order.paymentStatus,
            style: { width: "100px", paddingLeft: pl },
            full: true
          },
          {
            value: order.status,
            style: { width: "100px", paddingLeft: pl },
            full: true

          }
          );
        }


      var header = [{
        name: "Order",
        style: { paddingLeft: pl, width: seventyFive }
      },
      {
        name: "Name",
        style: { width: oneFifty, paddingLeft: pl }
      },
      {
        name: "Address",
        style: { width: "200px", paddingLeft: pl },
        full: true
      },
      {
        name: "Phone",
        style: { width: seventyFive, paddingLeft: pl },
        full: true
      },
      {
        name: "Email",
        style: { width: oneFifty, paddingLeft: pl },
        full: true
      }];

      if (this.props.mulchYear.sellHardwood) {
        header.push(
      {
        name: "Hwd",
        style: { width: fifty, paddingLeft: pl }
      })
    }

    if (this.props.mulchYear.sellCedar) {
      header.push(
      {
        name: "Cdr",
        style: { width: fifty, paddingLeft: pl }
      })
    }

    if (this.props.mulchYear.sellBlack) {
      header.push(
      {
        name: "Blk",
        style: { width: fifty, paddingLeft: pl }
      })
    }

    if (this.props.mulchYear.sellRed) {
      header.push(
      {
        name: "Red",
        style: { width: fifty, paddingLeft: pl }
      })
    }
    header.push(
      {
        name: "Paid",
        style: { width: "100px", paddingLeft: pl },
        full: true
      },
      {
        name: "Status",
        style: { width: "100px", paddingLeft: pl },
        full: true
      }
      );
   
      let salesSummary = null;
      if (this.props.summary)
      {
          salesSummary = <SalesSummary />
      }

      return (

        <Blank>
          <ToastContainer autoClose={3000} />
          {salesSummary}
          <Table header={header} data={data} editPopupHandler={this.showOrder}></Table>
        </Blank>
      );
    }
    else {
      return (
        <div>
          <Spinner />
        </div>
      );
    }
  }
}

const mapStateToProps = state => {
  return {
    mulchYear: state.orders.mulchYear,
    summary: state.orders.salesSummary,
    orders: state.orders.orders,
    loading: state.orders.loading
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onFetchScoutOrders: () => dispatch(actions.fetchScoutOrders()),
    onGetSalesSummary: ( forUSer) => dispatch( actions.getSalesSummary(forUSer) )
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ShowOrders);


// WEBPACK FOOTER //
// ./src/containers/Orders/ShowOrders/ShowOrders.js